import React, { useEffect } from 'react';
import './Legais.css';

function TermosUso() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="legais-page">
            <div className="legais-container">
                <div className="legais-header">
                    <h1>Termos e Condições Gerais de Uso</h1>
                    <p>Plataforma Agroov — Vigência a partir de 28 de Abril de 2026</p>
                </div>

                <div className="legais-section">
                    <h2>1. Do Objeto e da Natureza do Serviço</h2>
                    <p>O presente contrato estabelece as diretrizes para acesso e utilização das soluções tecnológicas do ecossistema digital <strong>Agroov</strong>. O Agroov atua na qualidade de classificado virtual de anúncios agropecuários e integrador de fretes rurais.</p>
                    <p>A plataforma <strong>não comercializa mercadorias</strong>. As operações financeiras de venda e envio são responsabilidade estrita dos participantes.</p>
                </div>

                <div className="legais-section">
                    <h2>2. Do Cadastro e Elegibilidade</h2>
                    <p>Para utilizar as ferramentas completas, o usuário deverá:</p>
                    <ul>
                        <li>Preencher com dados civis verídicos de CPF ou CNPJ.</li>
                        <li>Possuir plena capacidade civil legal (maior de 18 anos).</li>
                    </ul>
                    <p>O Agroov reserva-se o direito de suspender cadastros suspeitos de fraude de forma imediata e unilateral.</p>
                </div>

                <div className="legais-section">
                    <h2>3. Responsabilidades Sanitárias e Documentais</h2>
                    <p>Por ser estritamente uma plataforma de aproximação e classificados (intermediadora), o <strong>Agroov não exige, não fiscaliza e não valida</strong> a emissão da Guia de Trânsito Animal (GTA) ou quaisquer outras licenças sanitárias.</p>
                    <p>A regularização documental para o trânsito e comercialização de animais vivos é de responsabilidade única, exclusiva e direta entre o <strong>Vendedor e o Comprador</strong>, conforme as leis e normas federais vigentes.</p>
                </div>

                <div className="legais-section">
                    <h2>4. Política de Pagamentos e Reembolsos</h2>
                    <p>A ativação de planos profissionais é intermediada pelo gateway Mercado Pago.</p>
                </div>

                <div className="legais-section">
                    <h2>5. Autorização de Divulgação em Redes Sociais</h2>
                    <p>Ao publicar um anúncio na plataforma Agroov, o usuário Anunciante concede <strong>licença de uso gratuita, irrestrita e não exclusiva</strong> para que o Agroov utilize as imagens, vídeos, descrições e dados públicos do anúncio para fins promocionais.</p>
                    <p>Tais divulgações poderão ocorrer livremente nas redes sociais oficiais da marca (como o <strong>Instagram</strong>, Facebook e TikTok) visando ampliar o alcance e a conversão comercial do próprio anúncio.</p>
                </div>
            </div>
        </div>
    );
}

export default TermosUso;
